import { TraitCode } from '@capital-markets-gateway/api-client-identity';
import {
  permissionsByEntity,
  useCheckAccountTraits,
  useCheckAccountType,
  useCheckPermissions,
} from '@cmg/auth';

const permissions = [permissionsByEntity.Investor.READ];

/**
 * The Investor Directory is a sellside surface gated on two independent things, matching what the
 * gateway enforces: the BUY_SIDE_DIRECTORY account trait entitles the firm to the feature, while
 * the Investor permission entitles the individual role to read investor data. A user can hold the
 * trait and still lack the permission — a sales trader, for instance — so the nav item checks both
 * rather than advertising a page whose queries would come back unauthorized.
 *
 * The route separately enforces the Investor permission through PrivateRouteContent.
 */
const useInvestorDirectoryAccess = () => {
  const hasInvestorPermission = useCheckPermissions(permissions);
  const hasInvestorDirectoryTrait = useCheckAccountTraits([TraitCode.BUY_SIDE_DIRECTORY]);
  const isSellSide = useCheckAccountType('SELL_SIDE');

  const isEntitledAccount = isSellSide && hasInvestorDirectoryTrait;

  return {
    canShowAccess: isEntitledAccount && hasInvestorPermission,
    canRenderRoute: isEntitledAccount,
  };
};

export default useInvestorDirectoryAccess;
